import './App.css';
import React from 'react';
import { BrowserRouter as Router, Route, Routes  } from 'react-router-dom';
import Header from './components/Header/Header';
import HeroSection from './components/HeroSection/HeroSection';
import Footer from './components/Footer/Footer';
import AboutUs from './components/AboutUs/AboutUs';
import ContactForm from './components/Contact-form/Contact-form';


function App() {
  return (
    <Router>
      <div className="App">
        <Header/>
        <Routes>
          <Route path="/" element={
            <>
              <HeroSection />
              <AboutUs />
              <Footer />
            </>
          } />
          <Route path="/contact" element={
            <>
              <ContactForm />
              <Footer />
            </>
          } />
        </Routes>
      </div>
    </Router>
  );
}


export default App;
